import React from 'react';
import { Box, Button, Grid, List, ListItemText, Typography } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import SendIcon from '@mui/icons-material/Send';
import { Stack } from '@mui/system';

export default function Footer() {
    return (
        <Box
            sx={{
                backgroundColor: '#333', // Example background color
                color: '#fff',
                padding: { xs: 4, md: 10 },
                paddingTop: 12,
                paddingBottom: 12,
                fontSize: { xs: "12px", md: "14px" },
            }}
        >
            <Grid container spacing={2} justifyContent="center">
                <Grid item md={6} lg={4}>
                    <Typography variant="body1">About us</Typography>
                    <Typography variant="caption">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.
                    </Typography>
                    <Box
                        sx={{
                            marginTop: 4,
                            color: '#ccc',
                        }}
                    >
                        <FacebookIcon sx={{ marginRight: 1 }} />
                        <TwitterIcon sx={{ marginRight: 1 }} />
                        <InstagramIcon />
                    </Box>
                </Grid>
                <Grid item md={6} lg={2}>
                    <Typography variant="body1">Information</Typography>
                    <List>
                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                About Us
                            </Typography>
                        </ListItemText>

                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                Order Tracking
                            </Typography>
                        </ListItemText>

                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                <a href="/faq" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'white' }}>FAQs</a>
                            </Typography>
                        </ListItemText>
                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'white' }}>Privacy & Policy</a>
                            </Typography>
                        </ListItemText>
                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                <a href="/information" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'white' }}>Talk to our Expert</a>
                            </Typography>
                        </ListItemText>
                    </List>
                </Grid>
                <Grid item md={6} lg={2}>
                    <Typography variant="body1">My account</Typography>

                    <List>
                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                Login
                            </Typography>
                        </ListItemText>

                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                My Cart
                            </Typography>
                        </ListItemText>

                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                My Account
                            </Typography>
                        </ListItemText>

                        <ListItemText>
                            <Typography lineHeight={2} variant="caption">
                                Wishlist
                            </Typography>
                        </ListItemText>
                    </List>
                </Grid>
                <Grid item md={6} lg={4}>
                    <Typography variant="body1">Newsletter</Typography>
                    <Stack>
                        <input
                            type="email"
                            placeholder="Email address"
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                marginBottom: '8px',
                                boxSizing: 'border-box',
                            }}
                        />
                        <Button
                            startIcon={<SendIcon sx={{ color: '#fff' }} />}
                            sx={{ marginTop: 4, marginBottom: 4 }}
                            variant="contained"
                            style={{ backgroundColor: '#007bff' }} 
                        >
                            Subscribe
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
